module.exports = __webpack_public_path__ + "media/images/gary-1d91e3ed6daf17e2c67d632e4460ffa4.jpg";